import { SignatureCoreCard } from "components/SignatureCoreCard";
import { Container, StyledDiv } from "./TeltecCore.styles";

export const TeltecCore = ({ accessToken }: any) => {
  return (
    <Container>
      <StyledDiv>
        <SignatureCoreCard accessToken={accessToken} />
      </StyledDiv>
    </Container>
  );
};
